module.exports = __webpack_public_path__ + "img/Skirt-Front-B9-Da-Fb-Hc-Ib-Ja.07721f1e.png";